import {colorMode} from '../foundations/colors'

// https://chakra-ui.com/docs/components/radio/theming
export default {
  baseStyle: {
    control: {
      _checked: {
        bg: 'mld.primary.100',
        borderColor: 'mld.primary.100',
        _hover: {
          bg: 'mld.primary.100',
          borderColor: 'mld.primary.100',
        },
      },
    },
  },
  variants: {
    mld: (props) => {
      return {
        container: {
          alignItems: 'start',
        },
        control: {
          marginTop: 'xxs',
          borderColor: colorMode('mld.neutral.700', 'mld.neutral.0')(props),
          _checked: {
            color: colorMode('mld.neutral.900', 'mld.neutral.0')(props),
            borderColor: colorMode('mld.neutral.900', 'mld.neutral.0')(props),
            backgroundColor: 'transparent',
          },
        },
      }
    },
  },
}
